import { useEffect, useRef, useState } from "react";
import { InfMDFesInterface, infMunDescargaInterface, SelectObjectRemoveInterface } from "../../../../interfaces";
import { ButtonEditar, ButtonRemover, ButtonTrash, JTable, JTBody, JTHead, JvCaption, SpanIcon } from "../../../../components/Components";
import { Button, Card, Col, Dropdown, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBox, faBuilding, faEllipsis, faGear, faPlus, faSave, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { addMDFe, clearMDFe, removeMDFe, updateMDFe } from "../../../../features/manifestoSlice";
import { RootState } from "../../../../app/store";
import { formatMoeda, getNumeroNota, getUuidV4, goToFocus, handleNumberOnly, isNumber } from "../../../../utils/utils";
import MDFesProdutoPerigoso from "./MDFesProdutoPerigoso";
import { useQuestion } from "../../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../../components/ModalMessage/useModalMessage";
import { Link } from "react-router-dom";
import MDFesUnidadeTransp from "./MDFesUnidadeTransp";

const initialForm: InfMDFesInterface = {
    chMDFe: '',
    SegCodBarra: '',
    municipio_id: 0,
    name: '',
    indReentrega: false,
    peri: [],
    infUnidTransp: [],
    id: 0,
}
interface ValueDelete extends SelectObjectRemoveInterface {
    idMDFe: number | string;
}
const LIMITE: number = 10000;

const MDFes: React.FC = () => {
    const dispatch = useDispatch();
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();
    const [saldo, setSaldo] = useState<number>(0);
    const [notaManifesto, setNotaManifesto] = useState<InfMDFesInterface>(initialForm);
    const [change, setChange] = useState<boolean>(false);
    const selectMunicipiosDescarregamento = useSelector((state: RootState) =>
        state.manifesto.selectMunicipiosDescarregamentos);
    const munDescarga = useSelector((state: RootState) => state.manifesto.manifesto.infMunDescarga);
    const munNFeSelectRef = useRef<HTMLSelectElement>(null);
    const segCodBarraRef = useRef<HTMLInputElement>(null);
    const chaveRef = useRef<HTMLInputElement>(null);
    const manifesto = useSelector((state: RootState) => state.manifesto.manifesto);
    const [selecionado, setSelecionado] = useState<number | string>('');
    const [showProdutoPerigoso, setShowProdutoPerigoso] = useState<boolean>(false);
    const [showUnidadeTransporte, setShowUnidadeTransporte] = useState<boolean>(false);
    const [idMDFe, setIdMDFe] = useState<number | string>(0);

    const handleCloseUnidadeTransporte = () => {
        setShowUnidadeTransporte(false);
        setSelecionado('');
    }

    const handleCloseProdutoPerigoso = () => {
        setShowProdutoPerigoso(false);
        setSelecionado('');
    }

    const handleNFeChange = (e: any) => {
        const { name, value } = e.target;
        setNotaManifesto((prev) => ({ ...prev, [name]: value }))
    }

    const validaPreenchimentoMDFe = () => {
        if (notaManifesto.chMDFe === "") {
            goToFocus(chaveRef);
            alertModal('Informe uma chave NDF-e.');
            return false;
        }

        if (!isNumber(notaManifesto.chMDFe)) {
            goToFocus(chaveRef);
            alertModal('Chave MDF-e aceita somente números.');
            return false;
        }

        if (notaManifesto.SegCodBarra?.trim() !== "") {
            if (!isNumber(notaManifesto.SegCodBarra?.trim().toString())) {
                goToFocus(segCodBarraRef);
                alertModal('Seg. Cod. Barras aceita somente números.');
                return false;
            }
        }

        if (notaManifesto.chMDFe.substring(20, 22) !== '58') {
            goToFocus(chaveRef);
            alertModal('Chave informada não é um MDF-e.');
            return false;
        }

        if (notaManifesto.chMDFe.length !== 44) {
            goToFocus(chaveRef);
            alertModal('Chave deve conter 44 caracteres.');
            return false;
        }

        if (munDescarga.flatMap((item: infMunDescargaInterface) => item.infMDFe).find((item: InfMDFesInterface) =>
            item.chMDFe === notaManifesto.chMDFe && item.id !== notaManifesto.id)) {
            goToFocus(chaveRef);
            alertModal('Chave já foi adicionada.');
            return false;
        }

        if (munDescarga.flatMap((item: infMunDescargaInterface) => item.infNFe).length >= LIMITE) {
            alertModal(`Limite de ${formatMoeda(LIMITE, 0)} MDF-e atingido.`);
            return false;
        }

        return true;
    }

    const handleAdd = () => {

        if (munNFeSelectRef.current && munNFeSelectRef.current?.value !== "") {
            const nomeMunicipio = munNFeSelectRef.current?.options[munNFeSelectRef.current?.selectedIndex].text || ''

            if (validaPreenchimentoMDFe()) {
                dispatch(addMDFe({
                    ...notaManifesto,
                    id: getUuidV4(),
                    name: nomeMunicipio,
                    municipio_id: parseInt(munNFeSelectRef.current?.value)
                }));
                setNotaManifesto(initialForm);
            }
        } else {
            alertModal("Selecione um município.");
            return;
        }
    }

    const handleRemover = async (value: ValueDelete) => {
        if (change) {
            alertModal('Existem alterações não salvas.');
            return;
        }
        setSelecionado(value.idMDFe)
        const confirmed = await confirm({
            message: <>Remover MDF-e: <strong>{getNumeroNota(value.title)}</strong> ?</>,
            title: "Confirmação"
        });

        if (confirmed) {
            dispatch(removeMDFe({ municipio_id: parseInt(value.id.toString()), id: value.idMDFe }));
        }
        setSelecionado('');
    }

    const handleRemoverTudo = async () => {
        if (change) {
            alertModal('Existem alterações não salvas.');
            return;
        }

        if (munDescarga.flatMap((item: infMunDescargaInterface) => item.infMDFe).length > 0) {
            const confirmed = await confirm({
                message: <>Remover todos os MDF-e ?</>,
                title: "Confirmação"
            });
            if (confirmed) {
                dispatch(clearMDFe());
            }
        }
    }

    const loadMDFe = (id: number | string, municipio_id: number, chMDFe: string) => {
        if (change) {
            alertModal('Existem alterações não salvas.');
            return;
        } else {
            const municipio = manifesto.infMunDescarga
                .find((item: infMunDescargaInterface) => item.municipio_id === municipio_id);
            const mdfe = municipio?.infMDFe?.find((item: InfMDFesInterface) => item.chMDFe === chMDFe);
            setNotaManifesto({ ...notaManifesto, ...mdfe, municipio_id: municipio_id, name: municipio?.name });
            setChange(true);
            setSelecionado(id);
        }
    }

    const handleUpdateMDFe = () => {

        if (validaPreenchimentoMDFe()) {
            dispatch(updateMDFe({
                ...notaManifesto,
                name: munNFeSelectRef.current?.options[munNFeSelectRef.current?.selectedIndex].text || ''
            }));
            setNotaManifesto(initialForm);
            setChange(false);
        }
        setSelecionado('');
    }

    const handleCancelarEdicao = () => {
        setChange(false);
        setSelecionado('');
        setNotaManifesto(initialForm);
    }

    const handleShowProdutoPerigoso = (id: number | string) => {
        if (change) {
            alertModal('Existem alterações não salvas.');
        } else {
            setIdMDFe(id);
            setShowProdutoPerigoso(true);
            setSelecionado(id);
        }
    }

    const handleShowUnidadeTransporte = (id: number | string) => {
        if (change) {
            alertModal('Existem alterações não salvas.');
        } else {
            setIdMDFe(id);
            setShowUnidadeTransporte(true);
            setSelecionado(id);
        }
    }

    useEffect(() => {
        const total = (munDescarga ?? []).reduce((acc: number, item: infMunDescargaInterface) => {
            return acc + (item.infMDFe?.length ?? 0);
        }, 0);
        setSaldo(total);

    }, [munDescarga])

    return (<>
        <Card className="mb-2">
            <Card.Header className="fw-bold">
                Formulário de inclusão da MDF-e
            </Card.Header>

            <Card.Body>
                <Row className="g-2 mb-3">
                    <Col md={4}>
                        <Form.Group controlId="mdfe-municipio_id">
                            <Form.Label>*Municipios</Form.Label>
                            <Form.Select name="municipio_id" value={notaManifesto.municipio_id} ref={munNFeSelectRef}
                                onChange={handleNFeChange} >
                                {selectMunicipiosDescarregamento?.map(item => {
                                    return (<option key={item.id} value={item.id}>{item.name}</option>);
                                })}
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group controlId="mdfe-chMDFe">
                            <Form.Label>*Chave MDF-e</Form.Label>
                            <Form.Control name="chMDFe" value={notaManifesto.chMDFe} type="text" maxLength={44}
                                ref={chaveRef}
                                onKeyUp={handleNumberOnly}
                                onChange={handleNFeChange} />
                        </Form.Group>
                    </Col>
                    <Col md={'auto'}>
                        <Form.Group controlId="mdfe-SegCodBarra">
                            <Form.Label>Seg. Cod. Barras</Form.Label>
                            <Form.Control name="SegCodBarra" value={notaManifesto.SegCodBarra} maxLength={36}
                                type="text" ref={segCodBarraRef}
                                onKeyUp={handleNumberOnly}
                                onChange={handleNFeChange} />
                        </Form.Group>
                    </Col>

                </Row>

                <Row className="g-2">
                    <Col md={'auto'} className="d-flex align-items-end ">
                        <Form.Group >
                            <Form.Switch className="mb-0" type="switch" name="active" label="ind. Reentrega?"
                                checked={notaManifesto.indReentrega}
                                onChange={(e) => setNotaManifesto({ ...notaManifesto, indReentrega: e.target.checked })}
                            />
                        </Form.Group>
                    </Col>
                </Row>


            </Card.Body>
            <Card.Footer>
                <Button className="active me-2" variant="primary"
                    disabled={change}
                    onClick={handleAdd}>
                    <FontAwesomeIcon icon={faPlus} /> Adicionar
                </Button>
                {change && (<>
                    <Button className="active me-2" variant="success"
                        disabled={!change}
                        onClick={handleUpdateMDFe}>
                        <FontAwesomeIcon icon={faSave} /> Salvar
                    </Button>
                    <Button className="active" variant="danger"
                        disabled={!change}
                        onClick={handleCancelarEdicao}>
                        <FontAwesomeIcon icon={faXmark} /> Cancalar
                    </Button>
                </>)}

            </Card.Footer>
        </Card>
        <JTable>
            <JvCaption>({saldo} de {formatMoeda(LIMITE, 0, 'decimal')} no máximo)</JvCaption>
            <JTHead >
                <tr>
                    <th className="text-center" style={{ width: '4rem' }}>
                        <ButtonTrash onClick={() => handleRemoverTudo()} />
                    </th>
                    <th>Municipio</th>
                    <th>Chave NF-e</th>
                    <th>Seg. Cod. Barras</th>
                    <th className="text-center" style={{ width: '2.5rem' }}>
                        <FontAwesomeIcon className="text-primary" icon={faGear} />
                    </th>
                </tr>
            </JTHead>
            <JTBody>
                {munDescarga?.map((item: infMunDescargaInterface) => (
                    <>
                        {item.infMDFe?.map((mdfe: InfMDFesInterface) => {
                            return (
                                <tr key={mdfe?.id} className={(mdfe.id?.toString()) === selecionado.toString() ? 'table-danger' : ''}>
                                    <td className="d-flex justify-content-around ">
                                        <ButtonRemover onClick={() => handleRemover({ id: item.municipio_id, title: mdfe?.chMDFe, idMDFe: mdfe.id ?? '' })} />
                                        <ButtonEditar onClick={() => loadMDFe(mdfe.id?.toString() ?? '', item.municipio_id, mdfe?.chMDFe)} />
                                    </td>
                                    <td>{item.name}</td>
                                    <td>{mdfe.chMDFe}</td>
                                    <td>{mdfe?.SegCodBarra}</td>
                                    <td className="text-center p-0 m-0">
                                        <Dropdown className="d-grid gap-2"  >
                                            <Dropdown.Toggle id="dropdown-basic" size="sm" title="Opções"
                                                variant=""
                                                className="no-caret rounded-1 btn btn-sm">
                                                <FontAwesomeIcon icon={faEllipsis} />
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item as={Link} to={``}
                                                    onClick={() => handleShowProdutoPerigoso(mdfe?.id?.toString() ?? 0)}>
                                                    <FontAwesomeIcon style={{ minWidth: '1.25rem' }} icon={faBuilding}
                                                        className="text-primary me-1" />
                                                    <SpanIcon count={mdfe?.peri?.length ?? 0} />
                                                    Produtos Perigosos ONU
                                                </Dropdown.Item>
                                                <Dropdown.Item as={Link} to={``}
                                                    onClick={() => handleShowUnidadeTransporte(mdfe?.id?.toString() ?? 0)}>
                                                    <FontAwesomeIcon style={{ minWidth: '1.25rem' }} icon={faBox}
                                                        className="text-info me-1" />
                                                    <SpanIcon count={mdfe?.infUnidTransp?.length ?? 0} />
                                                    Unidades de Transporte
                                                </Dropdown.Item>

                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </td>
                                </tr>
                            )
                        })}
                    </>
                ))}
            </JTBody>
        </JTable>
        <MDFesProdutoPerigoso show={showProdutoPerigoso} handleClose={handleCloseProdutoPerigoso} id={idMDFe} />
        <MDFesUnidadeTransp show={showUnidadeTransporte} handleClose={handleCloseUnidadeTransporte} id={idMDFe} />
        {ConfirmModal}
        {ModalMessageEl}
    </>)
}

export default MDFes;